/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchResponsePopupDto } from '../../models/search-response-popup-dto';

export interface PopupControllerSearch$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 팝업 타입
 */
  type?: ('NORMAL' | 'ADVERTISE' | 'ALL') | null;

/**
 * 팝업 상태
 */
  status?: ('WAITING' | 'SHOWING' | 'ENDED') | null;

/**
 * 대상 역할
 */
  targetRoles?: Array<'PARENT' | 'TEACHER'>;

/**
 * 대상 디바이스
 */
  targetDevices?: Array<'PC' | 'MOBILE'>;
}

export function popupControllerSearch(http: HttpClient, rootUrl: string, params: PopupControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchResponsePopupDto>> {
  const rb = new RequestBuilder(rootUrl, popupControllerSearch.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('type', params.type, {});
    rb.query('status', params.status, {});
    rb.query('targetRoles', params.targetRoles, {});
    rb.query('targetDevices', params.targetDevices, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchResponsePopupDto>;
    })
  );
}

popupControllerSearch.PATH = '/api/popups/search';
